import React, { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  IconChevron,
  IconEE,
  IconExcel,
  IconFI,
  IconHistory,
  IconLT,
  IconLV,
  IconPlayLeft,
  IconPlayRight,
  IconRollBack,
  IconRollBacked,
  XIcon,
  TechnoramaIcon,
} from "../Layout/Icons";
import { useState } from "react";
import Spinner from "./Spinner";
import useFetch from "../../hooks/useFetch";
import { prettyDateFormat } from "../../helpers/Utils";
import { CheckBoxInput } from "./Buttons";
import { ButtonConfirm } from "../buttons";
import { AnimatePresence, motion } from "framer-motion";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import { getImumXls, rollbackImumToPim } from "../../redux/Actions/imum_action";
import { Tooltip } from "antd";
import AntdConfirm from "../../helpers/AntdConfirm";

export default function ButtonWithImumHistory({ actions }) {
  const wrapperRef = useRef(null);

  const [active, setActive] = useState(false);
  const [activeButtons, setActiveButtons] = useState(false);

  const handlerActive = () => {
    setActive((prev) => {
      const val = !prev;
      if (val) setActiveButtons(false);

      // const custom_modal = document.getElementById("custom_modal");
      // if (val) custom_modal.classList.add("modal-wrapper-dark");
      // else if (!activeButtons)
      //   custom_modal.classList.remove("modal-wrapper-dark");
      return val;
    });
  };

  const handlerActiveButton = () => {
    setActiveButtons((prev) => {
      const val = !prev;
      if (val) setActive(false);
      // const custom_modal = document.getElementById("custom_modal");
      // if (val) custom_modal.classList.add("modal-wrapper-dark");
      // else if (!active) custom_modal.classList.remove("modal-wrapper-dark");
      return val;
    });
  };
  return (
    <div className={`d-flex ml-2`} ref={wrapperRef}>
      <StyledButton className="d-flex align-items-center justify-content-between cursor-pointer position-relative">
        <div
          className="flex-1 d-flex align-items-center justify-content-between "
          onClick={() => {
            handlerActiveButton();
          }}
        >
          <span
            className={`button-left`}
            style={{
              padding: "4px 9px 5px",
            }}
          >
            Export to Akeneo
          </span>
          <IconChevron className="mx-2" />
        </div>
        <div className="history-right" onClick={() => handlerActive()}>
          <IconHistory />
        </div>
        <AnimatePresence>
          {activeButtons && (
            <ActiveButtons
              wrapperRef={wrapperRef}
              actions={actions}
              onClose={() => setActiveButtons(false)}
            />
          )}
        </AnimatePresence>
      </StyledButton>
      <AnimatePresence>
        {active && (
          <ActiveHistory
            wrapperRef={wrapperRef}
            active={active}
            handlerActive={handlerActive}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

const ActiveHistory = ({ wrapperRef, active, handlerActive }) => {
  const onAction = () => {
    // alert("You clicked outside of me!");
    handlerActive();
  };
  useOutsideAlerter(wrapperRef, onAction);
  return (
    <motion.div
      className="ml-2"
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        zIndex: 100,
      }}
    >
      {/* <div className="mx-2" /> */}
      <div className="position-relative">
        <StyledButton
          className="d-flex align-items-center justify-content-between cursor-pointer position-relative"
          active={active}
        >
          <div
            className="mr-3"
            onClick={() => {
              if (active) return handlerActive();

              // onSubmit();
            }}
          >
            <span
              className={`button-left font-weight-bold`}
              style={{
                padding: "4px 9px 5px",
              }}
            >
              Exports history
            </span>
          </div>
          <div
            style={{
              padding: "7px 6px 7px 8px",
            }}
            onClick={handlerActive}
          >
            <XIcon />
          </div>
        </StyledButton>
        <FetchHistory />
      </div>
    </motion.div>
  );
};

const ActiveButtons = ({ wrapperRef, actions, onClose }) => {
  const onAction = () => {
    // alert("You clicked outside of me!");
    onClose();
  };
  useOutsideAlerter(wrapperRef, onAction);

  const [showCountries, setShowCountries] = useState("");
  return (
    <motion.div
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, origin: 1 }}
      className="position-absolute"
      style={{
        backgroundColor: "#D9D9D9",
        top: 35,
        left: 0,
        width: "100%",
        // border: "1px solid rgba(0, 0, 0, 0.15)",
        borderRadius: 4,
        border: "1px solid #D2D2D2",
        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <AnimatePresence>
        {actions.map((d, idx) => (
          <ActiveItem
            idx={idx}
            key={d.label}
            showCountries={showCountries}
            setShowCountries={setShowCountries}
            onClick={d.onClick}
            type={d.type}
          >
            {d.label}
          </ActiveItem>
        ))}
      </AnimatePresence>
    </motion.div>
  );
};

const ActiveItem = ({
  idx,
  onClick,
  children,
  showCountries,
  setShowCountries,
  type,
}) => {
  const active = showCountries == children;
  let styles = {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  };
  if (idx == 0) {
    styles = {
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    };
  }
  return (
    <div className="position-relative">
      <div
        className="text-black text-xs cursor-pointer d-flex align-items-center justify-content-between px-2 py-1"
        style={{
          backgroundColor: !active ? "#fff" : "#E9F6FE",
          ...styles,
        }}
        onClick={() =>
          setShowCountries((prev) => (prev == children ? "" : children))
        }
      >
        <div style={{ textAlign: "left" }}>{children}</div>
        <div className="ml-1">
          {active ? <IconPlayLeft /> : <IconPlayRight />}
        </div>
      </div>
      <AnimatePresence>
        {active && (
          <ShowCountries
            onClick={onClick}
            setShowCountries={setShowCountries}
            type={type}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export const ShowCountries = ({
  onClick,
  setShowCountries,
  mergeLang,
  type,
}) => {
  const [lang, setLang] = useState(
    ["LT", "LV", "EE", "FI"].filter((lang) =>
      window.identifier == "technorama"
        ? lang == "LT"
        : mergeLang
        ? mergeLang !== lang
        : true
    )
  );

  const langOptions = {
    LT: "Lithuania",
    LV: "Latvia",
    EE: "Estonia",
    FI: "Finland",
  };

  const onHangleChange = (val) => {
    return setLang((prev) => {
      if (prev.includes(val)) return prev.filter((d) => d !== val);
      return [...new Set([...prev, val])];
    });
  };

  const handleSelectedSubmit = () => {
    onClick(lang);
    setShowCountries("");
  };

  const handleFilteredSubmit = () => {
    onClick(lang, true);
    setShowCountries("");
  };

  const itsChecked = (val) => lang.includes(val);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="position-absolute"
      style={{
        minWidth: 169,
        left: mergeLang ? "-75px" : 174,
        top: mergeLang ? 30 : 0,
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-2 py-1"
        style={{
          borderTop: "1px solid #BFBFBF",
          borderRight: "1px solid #BFBFBF",
          borderLeft: "1px solid #BFBFBF",
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          backgroundColor: "#fff",
        }}
      >
        <div className="text-xs text-black font-weight-bold">
          {mergeLang
            ? `Merge ${langOptions[mergeLang]} prices to`
            : "Export countries"}
        </div>
        <div>
          <XIcon
            className="text-sm cursor-pointer"
            onClick={() => setShowCountries("")}
          />
        </div>
      </div>

      <div
        className="d-flex flex-column align-items-start justify-content-between px-2 py-2"
        style={{
          borderRight: "1px solid #BFBFBF",
          borderTop: "1px solid #BFBFBF",
          borderLeft: "1px solid #BFBFBF",
          backgroundColor: "#fff",
        }}
      >
        {mergeLang !== "LT" && (
          <CheckBoxInput
            text={
              <span>
                {window.identifier == "technorama" ? (
                  <TechnoramaIcon />
                ) : (
                  <IconLT />
                )}
                {"  "}
                {window.identifier == "technorama"
                  ? "Technorama"
                  : langOptions["LT"]}
              </span>
            }
            checked={itsChecked("LT")}
            onChange={() => onHangleChange("LT")}
          />
        )}

        {mergeLang !== "LV" && window.identifier !== "technorama" && (
          <div className="py-1">
            <CheckBoxInput
              text={
                <span>
                  <IconLV />
                  {"  "}
                  {langOptions["LV"]}
                </span>
              }
              checked={itsChecked("LV")}
              onChange={() => onHangleChange("LV")}
            />
          </div>
        )}

        {mergeLang !== "EE" && window.identifier !== "technorama" && (
          <CheckBoxInput
            text={
              <span>
                <IconEE />
                {"  "}
                {langOptions["EE"]}
              </span>
            }
            checked={itsChecked("EE")}
            onChange={() => onHangleChange("EE")}
          />
        )}

        {mergeLang !== "FI" && window.identifier !== "technorama" && (
          <CheckBoxInput
            text={
              <span>
                <IconFI />
                {"  "}
                {langOptions["FI"]}
              </span>
            }
            checked={itsChecked("FI")}
            onChange={() => onHangleChange("FI")}
          />
        )}
      </div>

      <ButtonConfirm
        className="btn btn-primary text-xs font-normal"
        style={{
          width: "100%",
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
        onClick={handleSelectedSubmit}
      >
        Submit selected
      </ButtonConfirm>

      {type === "disable_channel" && (
        <ButtonConfirm
          className="btn btn-primary text-xs font-normal"
          style={{
            width: "100%",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
          onClick={handleFilteredSubmit}
        >
          Submit filtered
        </ButtonConfirm>
      )}
    </motion.div>
  );
};

const FetchHistory = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);

  const { value, loading, error } = useFetch(
    `/api/v1/${window.identifier}/imums/log_items?page=${page}`,
    {},
    [page]
  );

  useEffect(() => {
    if (value) {
      setData((prev) => [...prev, ...value]);
    }
  }, [value]);

  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (
          entries[0].isIntersecting &&
          !loading &&
          value &&
          value.length > 0
        ) {
          setPage((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading]
  );

  return (
    <div
      className="position-absolute bg-white"
      style={{
        border: "1px solid #D9D9D9",
        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4,
        zIndex: 1000,
        width: "100%",
        maxHeight: 300,
        overflowX: "auto",
      }}
    >
      {error ? (
        <div className="d-flex align-items-center justify-content-center py-2">
          {JSON.stringify(error)}
        </div>
      ) : data.length == 0 ? (
        <div className="d-flex align-items-center justify-content-center py-2">
          No data...
        </div>
      ) : (
        data.map(({ id, created_at, fullname, deleted_at }, idx) => {
          return (
            <div
              key={id}
              ref={data.length - 1 == idx ? lastElementRef : null}
              className="d-flex justify-content-between mx-2 py-1"
              style={{
                borderBottom: "1px solid #E6E6E6",
              }}
            >
              <div>
                <div className="text-xss font-weight-bold">
                  {prettyDateFormat(created_at)}
                </div>
                <div className="text-xss">{fullname}</div>
              </div>
              <div className="ml-1">
                {deleted_at == null && (
                  <Tooltip placement="top" title="Rollback to pim">
                    <IconRollBack
                      className="text-sm cursor-pointer"
                      color="#000"
                      onClick={() => {
                        AntdConfirm({
                          onOk: () => {
                            rollbackImumToPim(id);
                            console.log("ok11");
                          },
                        });
                      }}
                    />
                  </Tooltip>
                )}
                {deleted_at != null && (
                  <Tooltip placement="top" title="Rollbacked">
                    <IconRollBacked
                      className="text-sm cursor-not-allowed"
                      color="#000"
                    />
                  </Tooltip>
                )}
              </div>
              <div className="ml-1">
                <Tooltip placement="top" title="Download">
                  <IconExcel
                    className="cursor-pointer"
                    onClick={() => {
                      getImumXls({
                        type: "get_log_xls",
                        ids: [id],
                        filter: null,
                      });
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          );
        })
      )}
      {loading && <Spinner />}
    </div>
  );
};

const StyledButton = styled.div`
  min-width: 170px;
  min-height: 26px;
  font-size: 11px;
  text-align: center;
  z-index: 100;
  color: ${(props) => (props.active ? "#212121" : "#fff")};
  background-color: ${(props) => (props.active ? "#fff" : "#03b0f7")};
  border-radius: ${(props) => (props.active ? `4px 4px 0px 0px` : "4px")};
  border: ${(props) => (props.active ? `1px solid #D9D9D9` : "1px solid none")};
  .button-left {
    align-self: center;
  }
  .history-right {
    background: #0281b5;
    border-left: 1px solid #016e9b;
    border-radius: 0px 3.2px 3.2px 0px;
    padding: 7px 6px 7px 8px;
  }
`;
